// Copyright (c) 2016 Deere & Company

import CalculationPanelContainer from './calculation-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.spa.claim,
    formValidation: state.claims.spa.formValidation,
    isEditable: state.claims.spa.isEditable,
    showAmountsInLocalCurrency: state.claims.spa.claim.showAmountsInLocalCurrency,
    specialAllowanceCalculations: state.claims.spa.claim.specialAllowanceCalculations
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(CalculationPanelContainer);



// WEBPACK FOOTER //
// ./src/claim/spa/components/calculation-panel/index.js